<div class="container">
  <div class="chart">
    <div class="chart__top">
      <!--Левая сторона-->
      <div class="chart__top__side">
        <div class="chart__top__side__elem">

          <div class="chart__top__side__elem__economy-number" [ngStyle]="{'font-weight':'550'}">{{summFormat(chartData.plan)}}
            <span [ngStyle]="{'font-size': '70%', 'margin-top': '3%','font-weight':'300'}">млрд.</span>
          </div>
          <div class="chart__top__side__elem__economy-caption">План за период</div>
        </div>
        <div class="chart__top__side__elem"
             *ngIf="(chartData.plannedRedemptionGCB!=0)"
        >
          <div class="chart__top__side__elem__caption">Остаток по выкупу ГЦБ</div>
          <div class="chart__top__side__elem__number">
              <div class="left_text">
                {{summFormat(chartData.plannedRedemptionGCB)}}
              </div>
              <div class="panel_circle_block">
                <div class="circle" [ngStyle]="{'background-color': 'rgba(255,255,255,1)'}"></div>
              </div>
            </div>
        </div>
        <div class="chart__top__side__elem"
             *ngIf="chartData.purchasedGCB>0"
        >
          <div class="chart__top__side__elem__caption">Приобрели ГЦБ за период</div>
          <div class="chart__top__side__elem__number">
            <div class="left_text">
              {{summFormat(chartData.purchasedGCB)}}
            </div>
            <div class="panel_circle_block">
              <div class="circle" [ngStyle]="{'background-color': 'rgba(72,121,251,1)'}"></div>
            </div>
          </div>
        </div>
        <div class="chart__top__side__elem"
             *ngIf="chartData.canceledGCB>0"
        >
          <div class="chart__top__side__elem__caption">Погашено ГЦБ на текущую дату</div>
          <div class="chart__top__side__elem__number">
              <div class="left_text">
                  {{summFormat(chartData.canceledGCB)}}
              </div>
              <div class="panel_circle_block">
                <div class="circle" [ngStyle]="{'background-color': 'rgba(3,219,6,1)'}"></div>
              </div>
            </div>
        </div>
      </div>
      <!--Левая сторона тонкая-->
      <div class="chart__top__side__thin">
        <div class="chart__top__side__thin__elem chart__top__side__thin__elem_z1 chart__top__side__elem__number_white" [ngStyle]="{'height':heightCalculate(chartData.amountUnderContract,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}"></div>
        <div class="chart__top__side__thin__elem chart__top__side__thin__elem_z2 chart__top__side__elem__number_blue"
             [ngStyle]="{'height':heightCalculate(chartData.amountUnderContract>chartData.purchasedGCB?chartData.purchasedGCB:chartData.amountUnderContract,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}">
        </div>
        <div class="chart__top__side__thin__elem chart__top__side__thin__elem_z3 chart__top__side__elem__number_green" [ngStyle]="{'height':heightCalculate(chartData.canceledGCB,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}"></div>
      </div>
      <!--Центр-->
      <div class="chart__top__center">
        <div class="chart__top__center__blue"
             [ngStyle]="{'height':heightCalculate(chartData.balanceFromSale,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}">
        </div>
        <div class="chart__top__center__orange"
             [ngStyle]="{'height':heightCalculate(chartData.balanceGCB,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}">
        </div>
      </div>
      <!--Правая сторона тонкая-->
      <div class="chart__top__side__thin">
        <div class="chart__top__side__thin__elem chart__top__side__thin__elem_z1 chart__top__side__elem__number_purple" [ngStyle]="{'height':heightCalculate(chartData.amountUnderContract,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}"></div>
        <div class="chart__top__side__thin__elem chart__top__side__thin__elem_z2 chart__top__side__elem__number_pink" [ngStyle]="{'height':heightCalculate(chartData.spentForConstructing,(chartData.plan < chartData.amountUnderContract)&&chartData.amountUnderContract!==0?chartData.amountUnderContract:chartData.plan)}"></div>
      </div>
      <!--Правая сторона-->
      <div class="chart__top__side">

        <div class="chart__top__side__elem">
          <div class="chart__top__side__elem__economy-number" [ngStyle]="{'font-weight':'550'}">{{(chartData.plan-chartData.amountUnderContract)>0?('+'+summFormat(chartData.plan-chartData.amountUnderContract)):summFormat(chartData.plan-chartData.amountUnderContract)}}
              <span [ngStyle]="{'font-size': '70%', 'margin-top': '3%','font-weight':'300'}">млрд.</span>
          </div>
          <div class="chart__top__side__elem__economy-caption">Экономия на строительстве</div>
        </div>
        <div class="chart__top__side__elem"
             *ngIf="chartData.amountUnderContract>0">
          <div class="chart__top__side__elem__caption">Заключено договоров за период</div>
          <div class="chart__top__side__elem__number" [ngStyle]="{'padding-left':'0%', 'padding-right':'3%'}">
            <div class="panel_circle_block" [ngStyle]="{'justify-content': 'flex-start'}">
              <div class="circle" [ngStyle]="{'background-color': 'rgba(89,7,123,1)'}"></div>
            </div>
            <div class="left_text" [ngStyle]="{'justify-content': 'flex-end'}">
                {{summFormat(chartData.amountUnderContract)}}
            </div>
          </div>
        </div>
        <div class="chart__top__side__elem"
             *ngIf="chartData.spentForConstructing!=null">
          <div class="chart__top__side__elem__caption">Освоено на строительство</div>
          <div class="chart__top__side__elem__number" [ngStyle]="{'padding-left':'0%', 'padding-right':'3%'}">
            <div class="panel_circle_block" [ngStyle]="{'justify-content': 'flex-start'}">
              <div class="circle" [ngStyle]="{'background-color': '#ff00ff'}"></div>
            </div>
            <div class="left_text" [ngStyle]="{'justify-content': 'flex-end'}">
                {{summFormat(chartData.spentForConstructing)}}
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--Нижняя часть графика-->
    <div class="chart_bottom_side">
      <div class="chart_bottom_side-caption">
        <div class="chart_bottom_side-caption text_top">Остатки средств от реализации</div>
        <div class="chart_bottom_side-caption text_bottom">Средства у МИО</div>
      </div>
      <div class="chart_bottom_side-amount">
        <div class="chart_bottom_side-amount amount_top"
        *ngIf="chartData.balanceFromSale!=null"
        >
          <div class="text">{{summFormat(chartData.balanceFromSale)}}</div>
          <div class="indicator"></div>
        </div>
        <div class="chart_bottom_side-amount amount_bottom"
        *ngIf="chartData.balanceGCB!=null"
        >
          <div class="text_amount_bottom">{{summFormat(chartData.balanceGCB)}}</div>
          <div class="indicator_amount_bottom"></div>
        </div>
      </div>
      <div class="chart_bottom_side-remainder">
        <div class="remainder">{{summFormat(chartData.balanceGCB + chartData.balanceFromSale)}}</div>
        <div class="remainder_text">Общий остаток</div>
      </div>
    </div>
    
  </div>
</div>
